import { useState } from 'react';
import SEO from '@/components/base/SEO';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import LatestSection from './components/LatestSection';
import CategoryOverview from './components/CategoryOverview';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';
import { siteFaqs } from '@/mocks/faq';

export default function Home() {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const schemaData = [
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '韩漫屋',
      url: 'https://www.hanmanwu.com',
      description: '韩漫屋-韩漫大全_好看的韩国漫画_免费韩漫在线观看-韩漫官网站',
      inLanguage: 'zh-CN',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://www.hanmanwu.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '韩漫屋',
      url: 'https://www.hanmanwu.com',
      description: '韩漫屋是官方认证的韩漫官网站，提供权威的韩漫大全与好看韩国漫画免费在线观看。',
      foundingDate: '2020',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        email: 'service@hanmanwu.com',
        availableLanguage: ['Chinese'],
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: siteFaqs.map((faq) => ({
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.answer,
        },
      })),
    },
  ];

  return (
    <>
      <SEO
        title="韩漫屋-韩漫大全_好看的韩国漫画_免费韩漫在线观看-韩漫官网站"
        description="韩漫屋作为官方认证的韩漫官网站，提供权威的韩漫大全与好看韩国漫画免费在线观看，收录海量热门韩国漫画资源，支持高清流畅阅读，每日更新最新章节，确保资源质量与阅读体验。"
        keywords="韩漫屋,韩漫大全,好看韩国漫画,免费在线观看,韩漫官网站,韩国漫画,韩漫在线阅读,热门韩漫推荐"
        canonicalUrl="https://www.hanmanwu.com/"
        ogType="website"
        schemaJsonLd={schemaData}
      />

      <main>
        <HeroSection />
        <FeaturedSection />
        <LatestSection />
        <CategoryOverview
          selectedCategory={selectedCategory}
          onCategoryChange={setSelectedCategory}
        />
        <FaqSection />
        <CtaSection />
      </main>
    </>
  );
}